import * as React from 'react'
import cn from 'classnames'
import { CycleStatus } from './utils'

const STATUS_CONFIG: Record<
  CycleStatus,
  { label: string; className: string; dotClassName: string }
> = {
  active: {
    label: 'Active',
    className: 'bg-[#E7F4EC] text-[#1B7F4B]',
    dotClassName: 'bg-[#1B7F4B]',
  },
  scheduled: {
    label: 'Scheduled',
    className: 'bg-[#F6F0E7] text-[#8A6A3D]',
    dotClassName: 'bg-[#8A6A3D]',
  },
  archived: {
    label: 'Archived',
    className: 'bg-gray-100 text-gray-600',
    dotClassName: 'bg-gray-500',
  },
}

export const StatusLabel = ({ status }: { status: CycleStatus }) => {
  const { label, className, dotClassName } = STATUS_CONFIG[status]

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-sm font-medium',
        className
      )}
    >
      <span className={cn('h-1.5 w-1.5 rounded-full', dotClassName)} />
      {label}
    </span>
  )
}
